// eslint-disable-next-line no-unused-vars
import PostRepository from '../../../domain/repositories/PostRepository';
// eslint-disable-next-line no-unused-vars
import Post from '../../../domain/entities/Post';

class CreatePostUseCase {
    /**
     * @param {PostRepository} postRepository
     */
    constructor(postRepository) {
        this.postRepository = postRepository;
    }

    /**
     * @param {object} postData
     * @param {string} postData.userId
     * @param {string} postData.userName
     * @param {string} [postData.userProfilePic]
     * @param {string} postData.content
     * @param {File} [postData.imageFile]
     * @returns {Promise<Post>}
     */
    async execute(postData) {
        // The repository handles the creation of the Post entity and Firebase interaction
        return this.postRepository.createPost(postData);
    }
}

export default CreatePostUseCase;
